import { FeaturesConfigurationResource } from "client/resources";
import { Reducer } from "redux";
import { combineReducers } from "redux";

enum ActionKeys {
    CONFIGURATION_FEATURES_FETCHED = "CONFIGURATION_FEATURES_FETCHED",
    OTHER_ACTION = "__any_other_action_type__"
}

interface IConfigurationFeaturesFetchedAction {
    type: ActionKeys.CONFIGURATION_FEATURES_FETCHED;
    features: FeaturesConfigurationResource;
}

interface IOtherAction {
    type: ActionKeys.OTHER_ACTION;
}

type ActionTypes =
    IConfigurationFeaturesFetchedAction |
    IOtherAction;

export const configurationActions = {
    featuresFetched: (features: FeaturesConfigurationResource): IConfigurationFeaturesFetchedAction => ({
        type: ActionKeys.CONFIGURATION_FEATURES_FETCHED,
        features
    })
};

export interface ConfigurationAreaState {
    readonly features: ConfigurationFeaturesState;
}

export interface ConfigurationFeaturesState {
    readonly isMultiTenancyEnabled: boolean;
    readonly isCommunityActionTemplatesEnabled: boolean;
    readonly isBuiltInRepoSyncEnabled: boolean;
}

const featuresReducer: Reducer<ConfigurationFeaturesState> = (state: ConfigurationFeaturesState = null, action: ActionTypes): ConfigurationFeaturesState => {
    switch (action.type) {
        case ActionKeys.CONFIGURATION_FEATURES_FETCHED:
            if (!action.features) {
                return null;
            }

            return {
                isBuiltInRepoSyncEnabled: action.features.IsBuiltInRepoSyncEnabled,
                isCommunityActionTemplatesEnabled: action.features.IsCommunityActionTemplatesEnabled,
                isMultiTenancyEnabled: action.features.IsMultiTenancyEnabled
            };
        default:
            return state;
    }
};

export const configurationArea = combineReducers<ConfigurationAreaState>({
    features: featuresReducer
});


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/configuration/reducers/configurationArea.ts